import { Table } from "antd";
import { CfdiComplementInfo } from "api/generated";
import dayjs from "dayjs";

import { Key } from "react";

interface CFDIsTableProps {
  CFDIs: CfdiComplementInfo[];
  isLoading?: boolean;
  onSelectionChange: (
    selectedId: string,
    selectedUUID: CfdiComplementInfo
  ) => void;
  type: "traspaso" | "venta" | "compra";
}

function CFDIsTable({
  CFDIs,
  isLoading = false,
  onSelectionChange,
  type,
}: CFDIsTableProps) {
  const columns = [
    {
      title: "CFDI",
      dataIndex: "fiscalId",
      align: "center" as const,
      render: (text: string) => (text ? text.toUpperCase() : ""),
      width: "14rem",
    },
    ...(type === "compra"
      ? [
          {
            title: "Emisor",
            dataIndex: "nameEmisor",
            align: "center" as const,
            width: "10rem",
          },
        ]
      : []),
    {
      title: "Volumen documentado",
      dataIndex: "volume",
      align: "center" as const,
      width: "7rem",
    },
    {
      title: "Precio compra/venta",
      dataIndex: "price",
      align: "center" as const,
      width: "7rem",
    },

    {
      title: "Fecha Y hora",
      dataIndex: "invoiceDate",
      align: "center" as const,
      width: "6rem",
      render: (invoiceDate: string) => {
        if (!invoiceDate) return "";
        return dayjs(invoiceDate).format("YYYY/MM/DD hh:mm:ss A");
      },
    },
    {
      title: "No. Identificación",
      dataIndex: "numberId",
      align: "center" as const,
      width: "8rem",
    },
    {
      title: "Descripción",
      dataIndex: "description",
      width: "12rem",
      align: "center" as const,
    },
  ];

  const rowSelection = {
    type: "radio" as const,
    onChange: (selectedRowKeys: Key[], selectedRows: CfdiComplementInfo[]) => {
      if (selectedRows.length > 0 && selectedRows[0].id) {
        onSelectionChange(selectedRows[0].id, selectedRows[0]);
      }
    },
  };

  return (
    <Table
      columns={columns}
      dataSource={CFDIs}
      rowKey="id"
      rowSelection={rowSelection}
      pagination={false}
      loading={isLoading}
      size="small"
      scroll={{
        x: 1500,
        y: "calc(100vh - 600px)",
      }}
    />
  );
}

export default CFDIsTable;
